/* eslint-disable react/prop-types */
import React, { CSSProperties, Component } from 'react';
import styles from './index.less';
import * as ShapeItems from '../../../editor/src/js/constants/shape-default-data';
import IconItem from './shape-item-icon';
import classNames from 'classnames';
import i18n from '@i18next/i18n';


interface TopMenuShapeElementProps {
    hideMenu?: boolean;
    hide: (...arg: any[]) => any;
    hideToolBar?: (...arg: any[]) => any;
    cropPicker?: boolean;
}

interface TopMenuShapeElementState {
    config: {
        vh: number;
        height: number;
    };
}

/**
 * shape菜单
 */
export default class TopMenuShapeElement extends Component<TopMenuShapeElementProps, TopMenuShapeElementState> {
    private subitems: typeof ShapeItems.ShapeMenuItems;
    private menuDom: HTMLElement|null;
    public constructor(props, context) {
        super(props, context);
        this.subitems = [ShapeItems.ShapeMenuItems[2], ShapeItems.ShapeMenuItems[1]]
            .concat(ShapeItems.ShapeMenuItems.slice(3, -1))
            .concat(ShapeItems.ShapeMenuItems[0])
            .concat(ShapeItems.ShapeMenuItems[8]);

        this.state = {
            config: {
                vh: 0,
                height: 0,
            },
        };
    }

    public shouldComponentUpdate() {
        const vh = document.body.clientHeight;
        if ((this.isMenu() && this.menuDom && this.menuDom?.scrollTop !== 0)) {
            this.menuDom.scrollTop = 0;
        }
        return vh !== this.state.config.vh || this.state.config.height === 0;
    }


    public render() {
        const shapemw: CSSProperties = {
            width: '100%',
            maxHeight: '100%',
            overflowY: 'scroll',
            marginTop: -8,
            paddingBottom: 4,
            backgroundColor: 'white',
        };
        const wrapperClassName = classNames({
            'menu-scroll': true,
        });
        return (
            <div ref={(ref) => {
                this.menuDom = ref;
            }} className={wrapperClassName} style ={shapemw}   key={'shape-menu-wrapper'}>
                <div className={styles.toptitle}>{i18n.t('插入形状')}</div>
                <div className={styles.divider}/>
                {this.subitems.map(subitem => <div key={`thumb-${subitem.grouptype}`}>
                    <div id={`thumb-${subitem.grouptype}`}  key={`wrapper-${subitem.grouptype}`} className={styles.thumbt} >{subitem.grouptype}</div>
                    <div key={`title-${subitem.grouptype}`} className = {styles.thumbiw}>
                        {
                            subitem.groupvalue.map(item => <IconItem
                                key = {`item-${item.type}`}
                                {...item}
                                groupType = {subitem.grouptype}
                                groupid = {subitem.groupid}
                                hideMenu = {this.props.hide}
                                hideToolBar = {this.props.hideToolBar}
                                cropPicker = {this.props.cropPicker}
                            />)
                        }
                    </div>
                    {subitem.grouptype === i18n.t('动作按钮')
                        ? null
                        : <div className={styles.divider}/>
                    }

                </div>)
                }
            </div>
        );
    }

    private isMenu = () => (!!this.props.hideMenu);
}
